import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html'
})
export class ButtonComponent implements OnInit {
  @Input() appClass: string = '';
  @Input() appLabel: string = '';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Output() appClick = new EventEmitter<void>();
  constructor() { }

  ngOnInit(): void {
  }

  _click(){
    if (!this.loading && !this.disabled) {
      this.appClick.emit();
    }
  }
}
